import React from 'react';
import { Logo } from './Logo';
export function StickyBar() {
  const scrollToForm = () => {
    document.getElementById('formulario')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="fixed top-0 left-0 right-0 z-50 bg-deep-blue shadow-md py-3 px-6 md:px-10 flex items-center justify-between" data-id="element-253">
      <div className="flex items-center gap-3" data-id="element-254">
        <Logo className="w-8 h-8" data-id="element-255" />
        <span className="text-white font-playfair font-semibold text-lg hidden sm:block" data-id="element-256">
          RenuevaTE_90
        </span>
      </div>

      <div className="hidden lg:block text-champagne-gold text-sm font-montserrat tracking-wide" data-id="element-257">
        💙 25 Años Transformando Mujeres — Comparte Tu Historia Hoy
      </div>

      <button onClick={scrollToForm} className="bg-champagne-gold hover:bg-soft-gold text-white font-montserrat font-semibold text-sm py-2 px-5 rounded-full transition-colors duration-300 shadow-cta-shadow" data-id="element-258">
        Compartir Mi Historia →
      </button>
    </div>;
}